<template>
  <div>
    <div v-if="showHeader" class="modal-header">
      <span class="modal-header-title">{{ selectLabel }}</span>
    </div>
    <div class="modal-search-date-body">
      <DateCalendarPicker
        ref="dateCalendarPicker"
        :start-date-value="selectedCheckInDate"
        :end-date-value="selectedCheckOutDate"
        :start-date="startDate"
        :end-date="endDate"
        :disabled-dates="disableDates"
        always-visible
        @check-in-changed="handleCheckInChanged"
        @check-out-changed="handleCheckOutChanged"
      />
    </div>
  </div>
</template>

<script>
import DateCalendarPicker from 'vuejs/shared/components/DateCalendarPicker'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import 'dayjs/locale/ja'

dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Tokyo')
dayjs.locale('ja')

// Calendar and its state, without a container: DateSelectModal wraps it in a vue-js-modal,
// the official top page wraps it in a SearchSheet.
export default {
  components: {
    DateCalendarPicker,
  },
  props: {
    currentTime: {
      type: String,
      required: true,
    },
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
    checkInDate: {
      type: String,
      default: null,
    },
    checkOutDate: {
      type: String,
      default: null,
    },
    // The "select check-in / check-out" prompt above the calendar (hidden in the compact sheet).
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedCheckInDate: this.checkInDate,
      selectedCheckOutDate: this.checkOutDate,
    }
  },
  computed: {
    startDateObject() {
      return dayjs(this.startDate)
    },
    disableDates() {
      return []
    },
    selectLabel() {
      const selectedBoth = this.selectedCheckInDate && this.selectedCheckOutDate
      const selectedOnlyCheckIn = this.selectedCheckInDate && !this.selectedCheckOutDate

      if (selectedBoth) {
        return '日付を選択'
      } else if (selectedOnlyCheckIn) {
        return '出発日を選択してください'
      } else {
        return '到着日を選択してください'
      }
    },
  },
  methods: {
    handleCheckInChanged(date) {
      if (date) {
        this.selectedCheckInDate = date.format('YYYY-MM-DD')
      } else {
        this.selectedCheckInDate = null
      }
      this.selectedCheckOutDate = null
    },
    handleCheckOutChanged(date) {
      if (date) {
        this.selectedCheckOutDate = date.format('YYYY-MM-DD')
        this.$emit('updateValue', this.selectedCheckInDate, this.selectedCheckOutDate)
        // Both dates chosen: the container may close itself.
        this.$emit('completed')
      }
    },
    clearSelection() {
      this.selectedCheckInDate = null
      this.selectedCheckOutDate = null
      this.$emit('updateValue', null, null)
      if (this.$refs.dateCalendarPicker) {
        this.$refs.dateCalendarPicker.clearSelection()
      }
    },
  },
}
</script>
